import { render, staticRenderFns } from "./LicenceScopes.vue?vue&type=template&id=7d80b470&scoped=true"
import script from "./LicenceScopes.vue?vue&type=script&lang=js"
export * from "./LicenceScopes.vue?vue&type=script&lang=js"
import style0 from "./LicenceScopes.vue?vue&type=style&index=0&id=7d80b470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d80b470",
  null
  
)

export default component.exports